// extracted by css-extract-rspack-plugin
export default {"separatorContainer":"eKhnZxCa_8M0fvH5"};